import grispiApi from '../../apis/grispiApi';

export async function grispiNewsSubscribeToTickets({ ticketKeys, tabId }: { tabId: string; ticketKeys: string }) {
    if (ticketKeys && tabId) {
        const response = await grispiApi.post('/news/publish', {
            channel: `urn:s/${tabId}`,
            message: `s:${ticketKeys}`
        });
        return response.data;
    }
}

export async function checkGrispiNewsIsAlive() {
    const response = await grispiApi.get(`/healthcheck/news`);
    return response.data;
}
